'use client';

import Image from 'next/image';
import { useTranslations } from 'next-intl';

import { styles } from './Achievements.styles';
type AchievementsProps = {
  achievements: {
    id: string;
    title: string;
    image: string;
  }[];
};

export function Achievements({ achievements }: AchievementsProps) {
  const slots = styles();
  const t = useTranslations();

  return (
    <div className={slots.base()}>
      <h3 className={slots.title()}>{t('My achievements')}</h3>
      <div className={slots.items()}>
        {achievements.map((achievement) => (
          <div
            className={slots.item()}
            key={achievement.id}
          >
            <Image
              className={slots.image()}
              src={achievement.image}
              alt={achievement.title}
              width={160}
              height={160}
            />
            <span>{achievement.title}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
